<template>
    <div>
        <div class="lead">Поделиться результатом:</div>
        <ShareNetwork
            v-for="(network, idx) in networks"
            :key="idx"
            :network="network.network"
            :url="url"
            :media="media"
            :title="metaTitle"
            :description="metaDescription"
            class="quiz-app__share__item"
            :class="`quiz-app__share__item-${network.name}`"
            :style="{ 'background-color':network.color }"
        >
            {{ network.name }}
        </ShareNetwork>
    </div>
</template>

<script>
export default {
    name:'SocialShareComponent',
    props: {
        media: { required:true },
        url: { required:true }
    },
    computed: {
        metaTitle(){ return document.querySelector('meta[name="title"]').content },
        metaDescription(){ return document.querySelector('meta[name="description"]').content },
    },
    data: () => ({
        privateSharingData: {},
        networks: [
            { network: 'telegram', name: 'tg', color: '#0088cc' },
            // { network: 'facebook', name: 'fb', color: '#3d5b95' },
            { network: 'vk', name: 'vk', color: '#4a76a8' },
            { network: 'twitter', name: 'twitter', color: '#0f1419' },
            { network: 'odnoklassniki', name: 'ok', color: '#ed812b' },
        ]
    }),
    created(){
        Object.assign(this.privateSharingData, this.sharingData)
    }
}
</script>